import {
  Box,
  Stack,
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
  Heading,
} from '@chakra-ui/react'
import FirestoreUser from '../../../../types/FirestoreUser'
import {
  HistoryAccordionItem,
  MedicalConditions,
  InjuryHistory,
  SurgeryHistory,
  PrescriptionHistory,
  ChildhoodVaccineHistory,
  AdultVaccineHistory,
  AllergyHistory,
} from './components'
import { useMedicalHistoryData, useMedicalHistorySave } from './hooks'
import usePurpleBubblesText from '../../../../hooks/usePurpleBubblesText'
import PurpleBubbleContent from '../../../../components/PurpleBubbleContent'

interface Props {
  uid: string
  firestoreUser: FirestoreUser
}

const MedicalHistoryTab = ({ uid, firestoreUser }: Props) => {
  const {
    medicalHistory,
    setMedicalHistory,
    initialMedicalHistory,
    injuryHistory,
    setInjuryHistory,
    initialInjuryHistory,
    surgeryHistory,
    setSurgeryHistory,
    initialSurgeryHistory,
    childhoodVaccineHistory,
    setChildhoodVaccineHistory,
    initialChildhoodVaccineHistory,
    adultVaccineHistory,
    setAdultVaccineHistory,
    initialAdultVaccineHistory,
    allergyHistory,
    setAllergyHistory,
    initialAllergyHistory,
  } = useMedicalHistoryData(uid)

  const { isSaving, createSaveFunction } = useMedicalHistorySave(uid)
  const purpleBubbleContent = usePurpleBubblesText('Profile-step-3')

  return (
    <form>
      <Stack spacing={5}>
        {purpleBubbleContent?.text && (
          <PurpleBubbleContent text={purpleBubbleContent.text} />
        )}

        <Accordion defaultIndex={[]} allowToggle>
          <HistoryAccordionItem
            title='Medical History'
            isSaving={isSaving}
            onSave={createSaveFunction(
              medicalHistory,
              initialMedicalHistory,
              'medicalHistory'
            )}
          >
            <MedicalConditions
              uid={uid}
              firestoreUser={firestoreUser}
              medicalHistory={medicalHistory}
              setMedicalHistory={setMedicalHistory}
            />
          </HistoryAccordionItem>

          <HistoryAccordionItem
            title='Known Allergies'
            isSaving={isSaving}
            onSave={createSaveFunction(
              allergyHistory,
              initialAllergyHistory,
              'allergyHistory'
            )}
          >
            <AllergyHistory
              uid={uid}
              firestoreUser={firestoreUser}
              allergyHistory={allergyHistory}
              setAllergyHistory={setAllergyHistory}
            />
          </HistoryAccordionItem>

          <HistoryAccordionItem
            title='Injury History'
            isSaving={isSaving}
            onSave={createSaveFunction(
              injuryHistory,
              initialInjuryHistory,
              'injuryHistory'
            )}
          >
            <InjuryHistory
              uid={uid}
              firestoreUser={firestoreUser}
              injuryHistory={injuryHistory}
              setInjuryHistory={setInjuryHistory}
            />
          </HistoryAccordionItem>

          <HistoryAccordionItem
            title='Surgery History'
            isSaving={isSaving}
            onSave={createSaveFunction(
              surgeryHistory,
              initialSurgeryHistory,
              'surgeryHistory'
            )}
          >
            <SurgeryHistory
              uid={uid}
              firestoreUser={firestoreUser}
              surgeryHistory={surgeryHistory}
              setSurgeryHistory={setSurgeryHistory}
            />
          </HistoryAccordionItem>

          <AccordionItem>
            <AccordionButton>
              <Box flex='1' textAlign='left'>
                <Heading as='h2' size='md'>
                  Prescription Drug History
                </Heading>
              </Box>
              <AccordionIcon />
            </AccordionButton>
            <AccordionPanel pb={4}>
              <PrescriptionHistory uid={uid} firestoreUser={firestoreUser} />
            </AccordionPanel>
          </AccordionItem>

          <HistoryAccordionItem
            title='Childhood Vaccine History'
            isSaving={isSaving}
            onSave={createSaveFunction(
              childhoodVaccineHistory,
              initialChildhoodVaccineHistory,
              'childhoodVaccineHistory'
            )}
          >
            <ChildhoodVaccineHistory
              uid={uid}
              firestoreUser={firestoreUser}
              childhoodVaccineHistory={childhoodVaccineHistory}
              setChildhoodVaccineHistory={setChildhoodVaccineHistory}
            />
          </HistoryAccordionItem>

          <HistoryAccordionItem
            title='Adult Vaccine History'
            isSaving={isSaving}
            onSave={createSaveFunction(
              adultVaccineHistory,
              initialAdultVaccineHistory,
              'adultVaccineHistory'
            )}
          >
            <AdultVaccineHistory
              uid={uid}
              firestoreUser={firestoreUser}
              adultVaccineHistory={adultVaccineHistory}
              setAdultVaccineHistory={setAdultVaccineHistory}
            />
          </HistoryAccordionItem>
        </Accordion>
      </Stack>
    </form>
  )
}

export default MedicalHistoryTab
